/* Siete Notas — interacciones de los módulos 7N sobre Horizon */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Aviso -------------------------------------------------------------- */
  var toastTimer;
  function toast(message, isError) {
    var el = document.getElementById('sn-toast');
    if (!el) return;
    el.querySelector('[data-toast-text]').textContent = message;
    el.classList.toggle('sn-is-error', !!isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* Carrito: agrega y actualiza la burbuja del carrito de Horizon ----------- */
  function refreshBubble() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('cart-icon').forEach(function (icon) {
          if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
        });
      })
      .catch(function () {});
  }

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'No se pudo agregar.');
        return data;
      });
    }).then(function (data) {
      refreshBubble();
      var count = items.reduce(function (n, i) { return n + (i.quantity || 1); }, 0);
      toast(count > 1 ? 'Se agregaron ' + count + ' productos a tu carrito' : 'Agregado a tu carrito');
      return data;
    }).catch(function (err) {
      toast(err.message, true);
      throw err;
    });
  }
  window.SNAddItems = addItems;

  function withLoading(btn, promise) {
    btn.classList.add('sn-is-loading');
    return promise.finally(function () { btn.classList.remove('sn-is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      withLoading(quick, addItems([{ id: Number(quick.dataset.quickAdd), quantity: 1 }])).catch(function () {});
      return;
    }
    var multi = e.target.closest('[data-add-multiple]');
    if (multi) {
      e.preventDefault();
      try { withLoading(multi, addItems(JSON.parse(multi.dataset.addMultiple))).catch(function () {}); } catch (err) {}
    }
  });

  /* Promesa de entrega con hora de Lima ------------------------------------------------ */
  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']; function snAddDays(ymd, k) { var d = new Date(ymd + 'T12:00:00Z'); if (isNaN(d)) return ''; d.setUTCDate(d.getUTCDate() + k); return d.toISOString().slice(0, 10); }
  function limaNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Lima', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    var get = function (t) { return (parts.find(function (p) { return p.type === t; }) || {}).value; };
    return { day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday')), h: Number(get('hour')) % 24, m: Number(get('minute')), ymd: get('year') + '-' + get('month') + '-' + get('day') };
  }

  if (!customElements.get('sn-delivery')) {
    customElements.define('sn-delivery', class extends HTMLElement {
      connectedCallback() {
        this.render();
        this.timer = setInterval(this.render.bind(this), 60000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      render() {
        var cutoff = Number(this.dataset.cutoff || 15);
        var sat = this.dataset.sat === 'true';
        var sun = this.dataset.sun === 'true'; var hol = (this.dataset.holidays || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var deliversOn = function (d) { return d === 6 ? sat : d === 0 ? sun : true; };
        var textEl = this.querySelector('[data-delivery-text]');
        if (!textEl) return;
        var n = limaNow();
        if (deliversOn(n.day) && hol.indexOf(n.ymd) === -1 && n.h < cutoff) {
          var mins = cutoff * 60 - (n.h * 60 + n.m);
          var h = Math.floor(mins / 60), m = mins % 60;
          textEl.innerHTML = 'Pide en las próximas <strong>' + (h > 0 ? h + ' h ' : '') + m + ' min</strong> y te llega <strong>hoy hasta las 9 p. m.</strong> en Lima y Callao.';
        } else {
          var next = (n.day + 1) % 7, add = 1;
          while ((!deliversOn(next) || hol.indexOf(snAddDays(n.ymd, add)) !== -1) && add < 14) { next = (next + 1) % 7; add++; }
          textEl.innerHTML = 'Pide hoy y te llega <strong>' + (add === 1 ? 'mañana' : 'el ' + DAYS[next]) + '</strong> de 10 a. m. a 6 p. m. en Lima y Callao.';
        }
      }
    });
  }
})();


/* Medición (C24, 02/10): avisa a Shopify de cada clic de WhatsApp y de cada test completado.
   Los recibe cualquier píxel que se conecte después (Google, Meta) en Configuración > Eventos de clientes. */
(function () {
  function snPublish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]') : null;
    if (!a) return;
    var origen = a.closest('.sn-wa-float') ? 'flotante' : a.closest('[data-quiz]') ? 'test' : (location.pathname.indexOf('/products/') > -1 ? 'ficha' : 'otro');
    var h1 = document.querySelector('h1');
    snPublish('sn_whatsapp_click', { origen: origen, pagina: location.pathname, titulo: h1 ? h1.textContent.trim() : document.title });
  }, true);

  var res = document.querySelector('[data-quiz] .sn-quiz__result');
  if (res && 'MutationObserver' in window) {
    var sent = false;
    new MutationObserver(function () {
      if (res.hidden) { sent = false; return; }
      if (sent) return;
      sent = true;
      var t = res.querySelector('.sn-page-title');
      snPublish('sn_quiz_completado', { nota: t ? t.textContent.replace(/^\s*Tu nota es\s*/i, '').trim() : '' });
    }).observe(res, { attributes: true, attributeFilter: ['hidden'] });
  }
})();
